import { SignatureType, SiwxMessage } from './siwx.js';
export class SiwsMessage extends SiwxMessage {
    toMessage() {
        return super.toMessage('Solana');
    }
    signMessage() {
        let message;
        switch(this.type){
            case SignatureType.PERSONAL_SIGNATURE:
                {
                    message = new TextEncoder().encode(this.toMessage());
                    break;
                }
            default:
                {
                    message = new TextEncoder().encode(this.toMessage());
                    break;
                }
        }
        return message;
    }
}
